import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectDVCPMATrackingForecastSubpage } from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import { useListAgroTrackingForecastPreferencesQuery } from 'services/api/Meteorology/Agro/TrackingForecast/DetailedView';
import { SUBPAGE_SUBMENU_OPTIONS } from 'types/Meteorology/Agro/TrackingForecast/DetailedView';

export default function useListPreferences() {
  const subpage = useSelector(selectDVCPMATrackingForecastSubpage);
  const submenu = SUBPAGE_SUBMENU_OPTIONS[subpage];

  const { data, error, isLoading } = useListAgroTrackingForecastPreferencesQuery();

  const preferences = useMemo(() => {
    if (!data || !submenu) {
      return [];
    }

    return data.filter((preference) => preference.submenu === submenu);
  }, [data, submenu]);

  return {
    preferences,
    isLoading,
    error,
  };
}
